import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {Toaster} from "react-hot-toast";
import "bootstrap/dist/css/bootstrap.css"
import {AppContextProvider} from "./context/appContext";

ReactDOM.render(
  <React.StrictMode>
      <Toaster />
      <BrowserRouter>
          <AppContextProvider>
              <App />
          </AppContextProvider>
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
